import {AccountPerformanceView, accountPerformanceView} from "./view/AccountPerformanceViewComponent";

import Components from "./components";
import Services from "./service";
import {routerConfig} from "./RouterConfig";
import {performanceTimeFrameFilter, PerformanceTimeFrameFilter} from "./filters/TimeFrameFilter";

const rootDir = `app/performance`;

export default angular.module("tfApp.performance", [Components(rootDir), Services])
                      .config(routerConfig)
                      .filter(PerformanceTimeFrameFilter, performanceTimeFrameFilter)
                      .component(AccountPerformanceView, accountPerformanceView())
                      .name;
